export const colors = {
  // Primary Theme Colors
  primary: "#FFFFFF",
  secondary: "#1B4332",
  accent: "#C9A227",

  // Backgrounds & Surfaces
  background: "#FAFAFA",
  surface: "#FFFFFF",
  surfaceSecondary: "#F3F4F6",
  surfaceHover: "#F9FAFB",

  // Typography
  textPrimary: "#111827",
  textSecondary: "#6B7280",
  textMuted: "#9CA3AF",
  textLight: "#FFFFFF",
  textDark: "#111827",
  textInverse: "#FFFFFF",

  // Borders & Dividers
  border: "#E5E7EB",
  divider: "#F3F4F6",

  // Cards
  card: "#FFFFFF",
  cardHover: "#FFFFFF",

  // Overlays & Modals
  overlay: "rgba(0, 0, 0, 0.5)",
  modalBackground: "#FFFFFF",
  modalHeader: "#FFFFFF",
  modalFooter: "#F9FAFB",

  // Tables
  tableHeader: "#1B4332",
  tableHeaderText: "#FFFFFF",
  tableRow: "#FFFFFF",
  tableHover: "#F9FAFB",

  // Inputs & Forms
  inputBackground: "#FFFFFF",
  inputBorder: "#D1D5DB",
  inputPlaceholder: "#9CA3AF",

  // Buttons
  buttonPrimary: "#1B4332",
  buttonHover: "#2D6A4F",
  buttonText: "#FFFFFF",
  buttonPrimaryHover: "#2D6A4F",
  buttonPrimaryText: "#FFFFFF",
  buttonSecondary: "#FFFFFF",
  buttonSecondaryText: "#1B4332",
  buttonSecondaryBorder: "#1B4332",

  // Badges & Statuses
  badgeSuccess: "#16A34A",
  badgeSuccessText: "#FFFFFF",
  badgeWarning: "#F59E0B",
  badgeWarningText: "#111827",
  badgeDanger: "#DC2626",
  badgeDangerText: "#FFFFFF",
  badgeInfo: "#2563EB",
  badgeInfoText: "#FFFFFF",

  // Feedback Statuses
  success: "#16A34A",
  warning: "#F59E0B",
  danger: "#DC2626",
  info: "#2563EB",

  // Footer & Navbar
  footer: "#0B2E22",
  footerText: "#FFFFFF",
  footerLink: "#D1D5DB",
  footerLinkHover: "#C9A227",

  navbar: "#1B4332",
  navbarText: "#FFFFFF",
  navbarHover: "#C9A227",

  // Icons & Shadows
  icon: "#1B4332",
  iconHover: "#2D6A4F",
  shadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
};

export const applyTheme = (themeColors = colors) => {
  if (typeof document === "undefined") return;
  const root = document.documentElement;

  const mapping = {
    primary: themeColors.primary,
    secondary: themeColors.secondary,
    accent: themeColors.accent,
    background: themeColors.background,
    surface: themeColors.surface,
    "surface-secondary": themeColors.surfaceSecondary || "#F3F4F6",
    "surface-hover": themeColors.surfaceHover || "#F9FAFB",
    "text-primary": themeColors.textPrimary,
    "text-secondary": themeColors.textSecondary,
    "text-muted": themeColors.textMuted || "#9CA3AF",
    "text-light": themeColors.textLight || "#FFFFFF",
    "text-dark": themeColors.textDark || "#111827",
    "text-inverse": themeColors.textInverse || "#FFFFFF",
    border: themeColors.border,
    divider: themeColors.divider || "#F3F4F6",
    card: themeColors.card || "#FFFFFF",
    "card-hover": themeColors.cardHover || "#FFFFFF",
    overlay: themeColors.overlay || "rgba(0,0,0,0.5)",
    "modal-background": themeColors.modalBackground || "#FFFFFF",
    "modal-header": themeColors.modalHeader || "#FFFFFF",
    "modal-footer": themeColors.modalFooter || "#F9FAFB",
    "table-header": themeColors.tableHeader || "#1B4332",
    "table-header-text": themeColors.tableHeaderText || "#FFFFFF",
    "table-row": themeColors.tableRow || "#FFFFFF",
    "table-hover": themeColors.tableHover || "#F9FAFB",
    "input-background": themeColors.inputBackground || "#FFFFFF",
    "input-border": themeColors.inputBorder || "#D1D5DB",
    "input-placeholder": themeColors.inputPlaceholder || "#9CA3AF",
    "button-primary": themeColors.buttonPrimary || "#1B4332",
    "button-primary-hover": themeColors.buttonHover || themeColors.buttonPrimaryHover || "#2D6A4F",
    "button-primary-text": themeColors.buttonText || themeColors.buttonPrimaryText || "#FFFFFF",
    "button-secondary": themeColors.buttonSecondary || "#FFFFFF",
    "button-secondary-text": themeColors.buttonSecondaryText || "#1B4332",
    "button-secondary-border": themeColors.buttonSecondaryBorder || "#1B4332",
    "badge-success": themeColors.badgeSuccess || "#16A34A",
    "badge-success-text": themeColors.badgeSuccessText || "#FFFFFF",
    "badge-warning": themeColors.badgeWarning || "#F59E0B",
    "badge-warning-text": themeColors.badgeWarningText || "#111827",
    "badge-danger": themeColors.badgeDanger || "#DC2626",
    "badge-danger-text": themeColors.badgeDangerText || "#FFFFFF",
    "badge-info": themeColors.badgeInfo || "#2563EB",
    "badge-info-text": themeColors.badgeInfoText || "#FFFFFF",
    success: themeColors.success,
    warning: themeColors.warning,
    danger: themeColors.danger,
    info: themeColors.info,
    footer: themeColors.footer,
    "footer-text": themeColors.footerText || "#FFFFFF",
    "footer-link": themeColors.footerLink || "#D1D5DB",
    "footer-link-hover": themeColors.footerLinkHover || "#C9A227",
    navbar: themeColors.navbar || "#1B4332",
    "navbar-text": themeColors.navbarText || "#FFFFFF",
    "navbar-hover": themeColors.navbarHover || "#C9A227",
    icon: themeColors.icon || "#1B4332",
    "icon-hover": themeColors.iconHover || "#2D6A4F",
    shadow: themeColors.shadow || "0 4px 12px rgba(0, 0, 0, 0.08)",
  };

  Object.entries(mapping).forEach(([key, val]) => {
    root.style.setProperty(`--${key}`, val);
  });
};

export default colors;
